var _circle, _path, _path2, _path3, _path4, _circle2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDfbLogoL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1823,
    cy: 69.1823,
    r: 68.8071,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.634 108.387L115.984 112.409C109.164 119.798 100.693 125.47 91.2636 128.962L89.2125 123.402C97.7652 120.234 105.448 115.089 111.634 108.387Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8958 124.805L86.5046 130.509C75.1895 133.683 63.2199 133.687 51.9026 130.521L53.5114 124.817C63.7764 127.689 74.633 127.684 84.8958 124.805V124.805Z",
    fill: "#E60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1934 123.417L47.1418 128.977C37.7077 125.491 29.2317 119.823 22.4057 112.437L26.7565 108.415C32.9481 115.115 40.6363 120.255 49.1934 123.417Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.581 104.937C133.235 81.248 130.54 47.1975 108.391 26.7384C86.2415 6.27934 52.0845 6.28981 29.9477 26.7624C7.81089 47.2351 5.13646 81.2873 23.8057 104.965L19.153 108.634C-1.43072 82.5281 1.51832 44.9839 25.9256 22.4122C50.3328 -0.159407 87.9927 -0.170012 112.413 22.3879C136.833 44.9458 139.803 82.4883 119.234 108.606L114.581 104.937Z",
    fill: "#878787"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1822,
    cy: 69.1822,
    r: 51.7964,
    fill: "#00965A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8479 41.4322L115.478 58.6035L96.6398 69.417L115.478 80.4224L70.4014 106.45V97.7973L100.816 80.4224L89.3451 73.5732L64.0286 88.1724V110.126L56.5429 114.466V92.5084L37.5538 103.46L37.5933 35.4582L56.5429 46.406V24.5045L79.5754 37.7809V46.4595L64.0286 37.4918V50.7191L79.5754 59.6828V67.9639L64.0286 58.9444V79.5233L100.816 58.6035L85.8479 50.083V41.4322ZM45.0889 90.5009L56.5429 83.8359V54.6829L45.0592 48.0436L45.0889 90.5009Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfbLogoL);
export default __webpack_public_path__ + "static/media/dfb-logo-L.84ba17e2272ab5d70cc7238758efa583.svg";
export { ForwardRef as ReactComponent };